const isDialogOpen = state => state.isDialogOpen;
const isEmployeeFormStateEditable = state => state.isEmployeeFormStateEditable;

export default {
  isDialogOpen,
  isEmployeeFormStateEditable
};
